module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\"><i class=\"fa fa-fw fa-info-circle\"></i> Policies and Procedures</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\" ng-bind-html=\"$ctrl.html\">\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.cancel()\">OK</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/policies-and-procedures/policies-and-procedures.component.html
// module id = 668
// module chunks = 0